let $ = require('jquery');
const Velocity = require('velocity-animate');
require('./QuickWizard.less');
import _ from "underscore";
import jqueryValidationSoftCheck from "./additions";

const inputsSelector = "input, select, textarea";
const customValidatorSelector = "[data-qw-custom-validator]";
const validatableSelector = `${inputsSelector}, ${customValidatorSelector}`;

const notInputsSelector = ":submit, :reset, :image";
const hiddenDisabledSelector = ":hidden, :disabled";
const baseVelocityOpts = {
  duration: 300,
  easing: "ease"
};
/*
*   Long Term Todos For QuickWizard:
*     none
*
*
*
*/
//
// export QuickWizard to window
// so it can be referenced in the theme repo
// for external use (ricochet) and internal bundle
window.QuickWizard = QuickWizard;

function QuickWizard(el, options={}) {
  $ = options.$ || $;
  const self = this;
  let _formWasReady = false;
  let _formWasAttempted = false;
  let shouldStopRecurseAdjustHeightToCurrentForm = false;

  self.options = options;
  const customRules = self.options.customRules;
  const errorCheckDeferredArray = [];

  const wizardElement = $(el);
  self.wind = $(window);

  self.getWizardElement = ()=>{
    return wizardElement;
  };

  if(!wizardElement.length){ throw "First argument to QuickForm must be an element";}

  // public functions
  self.init = function(){
    findElements();
    addValidationMethods();
    calcAndSetWidthOfStepLinks();
    addStepNumbersToStepLinks();
    setDefaultActiveLink();
    slideToActiveForm();
    determineVisibleBtns();
    bindElements();
  };

  self.destroy = function(){
    $(window).off("resize", handleResize);
    wizardElement.off("wizard:reconcileHeight", adjustHeightOfFormsOuterToCurrentForm);
    $(document).off("focusout qwcustomchange", handleInputchangeForCurrentForm);
  };



  // public functions

  // this method set all the inputs on the tab to disable.
  self.setTabDisabled = function(tabArr){
    (tabArr).map((tabEl)=>{
      $(`${tabEl} :input`).attr('disabled', true);
      $(`${tabEl} a`).addClass('disabled');
    });
  }

  self.findValidatableElementsForScope = findValidatableElementsForScope;

  self.allPreviousFieldsUpToTargetForm = function(targetForm){
    return findValidatableElementsForScope(targetForm.prevAll());
  };

  self.gotToForm = function(form){
    const link = getLinkFromForm(form);
    attemptTraversalToTargetLink(link);
  };


  self.goToFirstIncompleteForm = function(){
    const form = self.getFirstIncompleteForm();
    self.gotToForm(form);
  };

  self.getFirstIncompleteForm = function(){
    let forms = self.getForms();

    // initialize firstInvalidForm with first form
    // incase no other forms are valid/finished.
    let firstInvalidForm = forms.get(0);

    // FYI: use es2015 find function, NOT jquery find,
    // this allows for short circuit filtering, which 
    // jquery does not
    firstInvalidForm = self.getForms().toArray().find((el)=>{
      const form = $(el);
      const inputs = findValidatableElementsForScope(form).not(notInputsSelector);

      // if given form is not valid,
      // short circuit
      if(!self.areInputsValid(inputs)){
        return true;
      }
    });

    return $(firstInvalidForm);
  };

  function getCurrentDirection(currentLink, targetLink) { 
    let currentDirection;
    let currentLinkLength = currentLink.prevAll().length;
    let targetLinkLength = targetLink.prevAll().length;
    if(targetLinkLength < currentLinkLength) {
      currentDirection = "BACKWARDS";
    } else {
      currentDirection = "FORWARDS";
    }
    return currentDirection;
  }

  function findValidatableElementsForScope(scope){
    return scope.find(validatableSelector);
  }


  self.hasAjaxValidationsPending = function(){
    return errorCheckDeferredArray.length;
  }

  function removeErrorsInternallyInJQueryValidation(validator, els){

  }

  // USE THIS PUBLIC VALIDATING FUNCTION
  // INSTEAD OF JQUERY VALID()
  // so you get custom validations
  // that are NOT element specific
  self.areInputsValid = function(inputs, {displayErrors, validationsComplete, filterAutoValidate: shouldFilter}={}){
    if(self.hasAjaxValidationsPending()){
      return "pending";
    }
    let result = true;
    const validator = wizardElement.validate();
    
    let el = validator.elements();
    if(shouldFilter){
      el = filterAutoValidate(el);
    }

    const jValidateEls = inputs.filter(el);

    // check jquery inputs 'valid' first
    jValidateEls.each(function(){
      const input = $(this);
      // validator.check() softly sets errors
      // within it's local error storage, which
      // is bad for use because jquery validation
      // then shows the error on it's next iteration
      
      setResult(jqueryValidationSoftCheck(validator, input, {$: $}));
    });
    // console.log(result);
    // validator.valid() does a SOFT validation
    // setResult(validator.valid());

    // validator.resetForm();

    if(displayErrors){
      // validator.prepareForm();
      // validator.resetForm();
      // elements.valid() does a HARD validation
      jValidateEls.length && jValidateEls.valid();
    }


    if(customRules){
      // First, remove inputs that jquery validate
      // cares about because we don't need them.
      // Second, filter any given element within
      // the customRules argument selector that is within inputs var.
      // If so, call custom validation, loop over customRules
      // calling given isValid cb.
      // if returns false, show error via selector, else hide
      inputs = inputs.filter(customValidatorSelector);

      _(customRules).each(function({isValid, errorMessageSelector}, selector){
        const input = inputs.filter(selector);
        if(input.length){
          const errorEl = $(errorMessageSelector);
          const doneCb = createDeferredDoneCb();
          const isValidValue = isValid({input, done: doneCb});

          if(isValidValue!==doneCb){
            doneCb(isValidValue);
          }


          function handleErrors(valid, options={}){
            // console.log(`handleErrors called with: ${valid}`);
            if(valid){
              setResult(true);
              if(displayErrors || options.displayErrors){
                hide(errorEl);
              }
            }
            else{
              setResult(false);
              if(displayErrors || options.displayErrors){
                show(errorEl);
              }
            }
          }

          function createDeferredDoneCb(){
            const deferred = new $.Deferred();
            errorCheckDeferredArray.push(deferred);
            return (isValidRetVal, options={})=>{
              const idx = _(errorCheckDeferredArray).indexOf(deferred);
              errorCheckDeferredArray.splice(idx, 1);
              handleErrors(isValidRetVal, options);
              deferred.resolve(isValidRetVal);
            }
          }
        }
      });
    }

    // handle callback style validation
    // in order to facilitate ajax based validation
    if(validationsComplete){
      $.when(...errorCheckDeferredArray).then(()=>{
        return validationsComplete(result);
      });
    }
    else{
      return result;
    }


    function setResult(res){
      // only set result if it hasn't
      // been set yet OR if it's not false already
      if(result !== false){
        result = res;
      }
    }
  };




  self.getForms = getForms.bind(self);
  self.getActiveTargetForm = getActiveTargetFormFromLink.bind(self);
  self.formIsReadyNow = formIsReadyNow.bind(self);

  // private functions

  function filterAutoValidate(el){
    return el.filter(()=>{
      return $(this).data("qw-auto-validate") !== "false";
    });
  }


  function findElements(){
    self.qwNavLinks = wizardElement.find('.qw-nav-step');
    self.nextBtn = wizardElement.find('.qw-next');
    self.prevBtn = wizardElement.find('.qw-prev');
  }

  function getLinkFromForm(form){
    form = $(form).get(0);
    if(!form){
      return $();
    }

    return self.qwNavLinks.filter(function() { 
      return $($(this).data("qw-form-target")).get(0) === form;
    });
  }



  function addStepNumbersToStepLinks(){
    self.qwNavLinks.each((i, el)=>{
      el = $(el);
      i = i + 1;
      let stepNum = el.find('.qw-step-num');
      if(!stepNum.length){
        stepNum = $("<span class='qw-step-num'></span>");
        el.prepend(stepNum);
      }
      stepNum.text(i);
    });
  }

  function formIsReadyNow(){
    quickPulse(self.nextBtn);
  }

  function calcAndSetWidthOfStepLinks(){
    const tl = totalLinks();
    const perc = 100/tl;
    self.qwNavLinks.css({width: `${perc}%`});
  }

  function totalLinks(){
    return self.qwNavLinks.length;
  }



  function recurseAdjustHeightToCurrentForm(){
    if(shouldStopRecurseAdjustHeightToCurrentForm || wizardElement.is(":hidden")){
      return;
    }
    adjustHeightOfFormsOuterToCurrentForm();
    return setTimeout(recurseAdjustHeightToCurrentForm.bind(self), 1000);
  }

  function bindElements(){
    // ALL RESIZE HANDLES
    $(window).on("resize", handleResize);
    handleResize();

    recurseAdjustHeightToCurrentForm();

    wizardElement.on("wizard:reconcileHeight", adjustHeightOfFormsOuterToCurrentForm);

    // NAV LINK CLICK
    self.qwNavLinks.bind('click', function(e){
      e.preventDefault();
      const el = $(this);
      self.options.onNavLinkClick && self.options.onNavLinkClick(e, {targetLink: el, wizardElement: wizardElement});
      attemptTraversalToTargetLink(el);
    });


    // NEXT BTN CLICK
    self.nextBtn.on('click', function(e){
      e.preventDefault();
      const currentLink = getActiveLink();
      let targetLink = currentLink.next();
      if(!targetLink.length){
        return;
      }
      self.options.onNextBtnClick && self.options.onNextBtnClick(e, {targetLink: targetLink, wizardElement: wizardElement});
      attemptTraversalToTargetLink(targetLink);
    });

    // PREV BTN CLICK
    self.prevBtn.on('click', function(e){
      e.preventDefault();
      const currentLink = getActiveLink();
      let targetLink = currentLink.prev();
      if(!targetLink.length){
        return false;
      }
      self.options.onNextPrevClick && self.options.onNextPrevClick(e, {targetLink: targetLink, wizardElement: wizardElement});
      attemptTraversalToTargetLink(targetLink);
    });

    // ORIGINALLY: change keyup blur paste qwcustomchange
    // we are changing to just focusout and custom event.
    // This will help
    $(document).on("focusout qwcustomchange", handleInputchangeForCurrentForm);
    // if(self.options.enableAutoValidateAllOnFocusout){
    //   $(document).on("focusout qwcustomchange", handleInputchangeForCurrentForm.bind(self));
    // }
    // $(document).on("keydown", handleTabKeyDown.bind(self));
  }

  // tabbing bugfix is inherently non-existent
  // now because the only visible form now is
  // the one that is active.
  
  // function handleTabKeyDown(e){
  //   if (e.keyCode === 9) {
  //     const form = getActiveTargetFormFromLink();
  //     const inputs = form.find(inputsSelector).not(notInputsSelector).not(hiddenDisabledSelector);
  //     const currentInput = e.target;
  //     const lastInput = inputs.last();
  //     // first check, simply see if the input is the last input
  //     // on the current form, if so, don't tab to next!
  //     if(currentInput === lastInput.get(0)){
  //       e.preventDefault();
  //       self.nextBtn.focus();
  //       return;
  //     }

  //     let s2 = lastInput.data('select2');

  //     // second check, if we are using a wrapped select
  //     // via select2 plugin, get the actual focused select2
  //     // and compare it to the target input
  //     if(s2 && s2.$selection && s2.$selection.filter($(currentInput)).length){
  //       e.preventDefault();
  //       self.nextBtn.focus();
  //     } 
  //   }
  // }

  function handleInputchangeForCurrentForm(e){
    const currentInput = $(e.target);
    const currentForm = getActiveTargetFormFromLink();
    if(currentForm.find(currentInput).length){
      // const currentInputs = findValidatableElementsForScope(currentForm);
      self.options.onInputChange && self.options.onInputChange({currentForm, currentInputs, currentInput});
      onInputChange(currentInput);
    }
  }

  const debouncedInputChange = _.debounce(onInputChange, 400);

  function onInputChange(currentInputs){
    currentInputs = currentInputs.not(notInputsSelector);

    // if the form was already attempted to traverse to the next form,
    // do a full validation and display erors
    const inputsValid = self.areInputsValid(currentInputs, 
      {
        displayErrors: false,
        filterAutoValidate: true
      }


    );


    // if the form was not ready and the inputs are valid,
    // execute the formIsReady function
    if(!_formWasReady && inputsValid){
      self.formIsReadyNow();
      _formWasReady = true;
    }
    // if the inputs are not valid,
    // then the form is was no longer ready
    else if(!inputsValid){
      _formWasReady = false;
    }
  }

  function handleResize(){
    // make sure that the width of the form
    // is not affecting the translateX value
    // of the sliding logic
    slideToActiveForm({noAnimation: true});
    handleNavStepsResize();
  }

  function handleNavStepsResize(){
    if(_.isNumber(self.options.mobileWidthNavStep)){
      if(self.wind.width() < self.options.mobileWidthNavStep){
        swapClasses(self.qwNavLinks, {fromClasses: "qw-nav-step-tablet", toClasses: "qw-nav-step-mobile"});
      }
      else if(self.wind.width() < self.options.tabletWidthNavStep){
        swapClasses(self.qwNavLinks, {fromClasses: "qw-nav-step-mobile", toClasses: "qw-nav-step-tablet"});
      }
      else{
        self.qwNavLinks.removeClass("qw-nav-step-mobile qw-nav-step-tablet");
      }
    }
  }

  function swapClasses(el, {fromClasses, toClasses}){
    el.removeClass(fromClasses);
    el.addClass(toClasses);
  }


  function determineVisibleBtns(){
    const currentLink = getActiveLink();
    if(self.qwNavLinks.last().get(0) === currentLink.get(0)){
      hide(self.nextBtn);
    }else{
      show(self.nextBtn);
    }

    if(self.qwNavLinks.first().get(0) === currentLink.get(0)){
      hide(self.prevBtn);
    }else{
      show(self.prevBtn);
    }
  }

  function hide(el){
    el.css('display', 'none');
  }

  function show(el){
    el.css('display', 'block');
  }

  function getTraversalDirection(current, target){
    let direction = "BACKWARDS";
    // if current link is before target link, direction is FORWARDS
    if(target.prevAll(current).length){
      direction = 'FORWARDS';
    }
    return direction;
  }



  function attemptTraversalToTargetLink(el, {skipCallbacks}={}){

    // return if:
    // 1. we already on the current active form,
    // 2. we have pending error checking ajax calls
    if(el.hasClass('active') || self.hasAjaxValidationsPending()){
      return;
    }


    const targetForm = getTargetFormFromLink(el);
    const currentLink = getActiveLink();
    const currentForm = getTargetFormFromLink(currentLink);


    const direction = getTraversalDirection(currentLink, el);
    // console.log(direction);
    //This direction was not returned correct, hence wrote a method to fix it 
    const currentDirection = getCurrentDirection(currentForm, targetForm);

    let canNav = true;
    if(!skipCallbacks){
      canNav = self.options.shouldNavigateToForm && self.options.shouldNavigateToForm({currentForm, targetForm, direction, done});
    }

    // if we are given back the callback
    // that we had originally passed in,
    // the developer is indicating that
    // we need to what for him/her to
    // call this callback to actually
    // get a value that we can rely
    // on to determine if we can actually
    // navigate

    // So, if the value returned from shouldNavigateToForm
    // is NOT our callback we passed in, we can assume
    // we can just manually call it ourselves (ie. no ajax).
    // Otherwise, don't call the callback, and wait
    // for developer to call it when ajax is finished
    if(canNav !== done){
      done(canNav);
    }



    function done(canNav){
      if(canNav !== false){
        const allPrevLinks = getAllLinksBefore(el);
        makeLinkVisited(allPrevLinks);
        makeLinkActive(el);
        slideToActiveForm();
        slideToTopOfWizard();
        adjustHeightOfFormsOuterToForm(targetForm);
        determineVisibleBtns();
        // we are on a new form, so it is not ready to start
        _formWasReady = false;
        _formWasAttempted = false;
        self.options.didNavigateToForm && self.options.didNavigateToForm({currentForm: targetForm, previousForm: currentForm, currentDirection: currentDirection});
      }else{
        _formWasAttempted = true;
        quickShake(currentForm.children(".qw-form-inner"));
      }
    }
  }

  self.didAttemptToNavigateAwayFromCurrentForm = function(){
    return _formWasAttempted;
  }


  function showAllForms(){
    getForms().css("visibility", "visible");
  }

  function hideAllFormsExcept(form){
    getForms().css("visibility", "hidden");
    form.css("visibility", "visible");
  }



  function adjustHeightOfFormsOuterToForm(form){
    getFormsOuter().css({
      height: form.outerHeight() + "px"
    });

  }

  function adjustHeightOfFormsOuterToCurrentForm(){
    adjustHeightOfFormsOuterToForm(getActiveTargetFormFromLink());
  }

  function getFormsOuter(){
    return wizardElement.find('.qw-forms-outer').first();
  }

  function slideToTopOfWizard(){
    $('html, body').animate({scrollTop: wizardElement.offset().top + "px"}, 200);
  }

  function quickShake(el){
    el.addClass('quick-shake');
    setTimeout(()=>{
      el.removeClass('quick-shake');
    }, 500);
  }

  function quickPulse(el){
    el.addClass('quick-pulse');
    setTimeout(()=>{
      el.removeClass('quick-pulse');
    }, 400);
  }



  function makeLinkVisited(el){
    getAllLinks().removeClass('visited');
    el.addClass('visited');
  }

  function makeLinkActive(el){
    self.qwNavLinks.removeClass('active');
    el.addClass('active');
  }

  function getIndexOf(form, forms){
    return forms.index(form);
  }

  function slideToActiveForm(options={}){
    let dur = 300;
    if(options.noAnimation){
      dur = 0;
    }
    const targetForm = getActiveTargetFormFromLink();
    const forms = getForms();
    const formsArray = forms.toArray();
    const idx = getIndexOf(targetForm, forms);
    const formWidth = targetForm.outerWidth();
    const left = 0 - (idx * formWidth);

    showAllForms();

    Velocity(formsArray, "stop");
    Velocity(forms.toArray(), {
      translateX: left + "px"
    }, {
      ...baseVelocityOpts, 
      duration: dur,
      complete: function(){
        hideAllFormsExcept(targetForm);
      }
    });
  }

  function getActiveTargetFormFromLink(){
    let activeLink = getActiveLink();
    return getTargetFormFromLink(activeLink);
  }

  function getTargetFormFromLink(link){
    return wizardElement.find(link.data('qw-form-target'));
  }

  function getActiveLink(){
    let activeLink = self.qwNavLinks.filter(".active");
    if(!activeLink.length){
      activeLink = self.qwNavLinks.first();
    } 
    else if(activeLink.length > 1){
      activeLink = activeLink.first();
    }
    return activeLink;
  }

  function getAllLinks(){
    return self.qwNavLinks;
  }

  function getAllLinksBefore(link){
    return link.prevAll(".qw-nav-step");
  }

  function setDefaultActiveLink(){
    getActiveLink().addClass('active');
  }

  function getForms(){
    return wizardElement.find('.qw-form');
  }
  function addValidationMethods(){
    $.validator.addMethod("notAllSpaces", function(value, element) { 
      return value.trim().length != 0;  
    }, "Value can't be all spaces");
  }

}

 

export default QuickWizard;


// WEBPACK FOOTER //
// ./src/components/QuickWizard/QuickWizard.js